"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.symbol = exports.getMetadata = exports.METADATA = void 0;
exports.METADATA = Symbol("metadata");
const getMetadata = o => o && o[exports.METADATA];
exports.getMetadata = getMetadata;
/////////////////////////////////
// For backwards-compatibility //
/////////////////////////////////
/**
 * @deprecated Use METADATA
 */
exports.symbol = exports.METADATA;
/**
 * @deprecated use getMetadata
 */
const get = o => o && o[exports.METADATA];
exports.get = get;
//# sourceMappingURL=metadata.js.map